import { render, staticRenderFns } from "./selectedCard.vue?vue&type=template&id=19a5f1de&scoped=true"
import script from "./selectedCard.vue?vue&type=script&lang=js"
export * from "./selectedCard.vue?vue&type=script&lang=js"
import style0 from "./selectedCard.vue?vue&type=style&index=0&id=19a5f1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5f1de",
  null
  
)

export default component.exports